type SoundKey =
  | "gong"
  | "menuMove"
  | "menuSelect"
  | "item"
  | "coin"
  | "sonar"
  | "sonarPickup"
  | "flame"
  | "rangeUp"
  | "key"
  | "doorOpen"
  | "doorUnlock"
  | "doorClosed"
  | "campFireBurning"
  | "fuelCharge"
  | "fuelLowCountdown"
  | "miningWallWood"
  | "miningWallStone"
  | "miningWallNether"
  | "wallMinedWood"
  | "wallMinedStone"
  | "wallMinedNether"
  | "buyItem"
  | "shopEnoughMoney"
  | "shopSelectionLow"
  | "noMoney"
  | "shopAnytime"
  | "shopNoMoney"
  | "shopThankYou"
  | "shopBuying"
  | "slowDeath"
  | "overconfidence"
  | "slowly"
  | "noHope"
  | "disappointment"
  | "impressive"
  | "victory"
  | "footstepGrass1"
  | "footstepGrass2"
  | "footstepStone1"
  | "footstepStone2"
  | "footstepNether1"
  | "footstepNether2";

export type FootstepSurface = "grass" | "stone" | "nether";
export type MiningSurface = "wood" | "stone" | "nether";
export type LowFuelWarningConfig = {
  threshold: number;
  minVolume: number;
  maxVolume: number;
  maxPlaybackRate: number;
};

export type MusicKey = "menu" | "credits" | "level1" | "dungeon" | "moonlight" | "horns" | "saveSpace";

const soundUrls: Record<SoundKey, string> = {
  gong: "/assets/sound/01_Hauptmenue/01_Audios/2_SOUND_Gong_Einstieg.wav",
  menuMove: "/assets/sound/01_Hauptmenue/01_Audios/1_1_SOUND_Menue_NO.wav",
  menuSelect: "/assets/sound/01_Hauptmenue/01_Audios/1_1_SOUND_Menue_YES.wav",
  item: "/assets/sound/Generell Sounds/paper_sound.wav",
  coin: "/assets/sound/05_Geräusche/SOUND_Bling_Money1_Clear_Short.wav",
  sonar: "/assets/sound/05_Geräusche/SOUND_Echolot_V1.wav",
  sonarPickup: "/assets/sound/05_Geräusche/SOUND_Echolot_V3.wav",
  flame: "/assets/sound/05_Geräusche/SOUND_Fire_Flame_V1.wav",
  rangeUp: "/assets/sound/Generell Sounds/swoosh_effect_up_shorted.wav",
  key: "/assets/sound/Generell Sounds/getting_key.wav",
  doorOpen: "/assets/sound/Generell Sounds/door_open.wav",
  doorUnlock: "/assets/sound/Generell Sounds/door_unlock.wav",
  doorClosed: "/assets/sound/Generell Sounds/closed_door_sound.wav",
  campFireBurning: "/assets/sound/05_Geräusche/SOUND_Fire_Burning.wav",
  fuelCharge: "/assets/sound/05_Geräusche/SOUND_CampFire_Refill_Placeholder.wav",
  fuelLowCountdown: "/assets/sound/01_WELT_Koriandergarten/01_Audios/2_SOUND_Item_Countdown.wav",
  miningWallWood: "/assets/sound/Generell Sounds/mining_wall_wood.wav",
  miningWallStone: "/assets/sound/Generell Sounds/mining_wall_stone.wav",
  miningWallNether: "/assets/sound/Generell Sounds/mining_wall_nether.wav",
  wallMinedWood: "/assets/sound/Generell Sounds/wall_mined_wood.wav",
  wallMinedStone: "/assets/sound/Generell Sounds/wall_mined_stone.wav",
  wallMinedNether: "/assets/sound/Generell Sounds/wall_mined_nether.wav",
  buyItem: "/assets/sound/05_Geräusche/SOUND_SHOP_Selection_High.wav",
  shopEnoughMoney: "/assets/sound/05_Geräusche/SOUND_SHOP_Enough_Money.wav",
  shopSelectionLow: "/assets/sound/05_Geräusche/SOUND_SHOP_Selection_Low.wav",
  noMoney: "/assets/sound/05_Geräusche/SOUND_SHOP_No_Money.wav",
  shopAnytime: "/assets/sound/00_Voice_Lines/Merchant_quote_-_Come_back_anytime-Kopie.wav",
  shopNoMoney: "/assets/sound/00_Voice_Lines/Merchant_quote_-_Not_enough_cash,_stranger.ogg",
  shopThankYou: "/assets/sound/00_Voice_Lines/Merchant_quote_-_Thank_you.ogg",
  shopBuying: "/assets/sound/00_Voice_Lines/Merchant_quote_-_What're_ya_buyin'.ogg",
  slowDeath: "/assets/sound/00_Voice_Lines/darkest-dungeon-the-slow-death.mp3",
  overconfidence: "/assets/sound/00_Voice_Lines/darkest-dungeon-remind-yourself-that-overconfidence.mp3",
  slowly: "/assets/sound/00_Voice_Lines/darkest-dungeon-slowly-gently-1.mp3",
  noHope: "/assets/sound/00_Voice_Lines/darkest-dungeon-there-can-be-no-hope-in-this-hell.mp3",
  disappointment: "/assets/sound/00_Voice_Lines/more-dust-more-ashes-more-disappointment.mp3",
  impressive: "/assets/sound/00_Voice_Lines/darkest-dungeon-impressive.mp3",
  victory: "/assets/sound/Generell Sounds/winning_sound.wav",
  footstepGrass1: "/assets/sound/Generell Sounds/footstep_grass_1.wav",
  footstepGrass2: "/assets/sound/Generell Sounds/footstep_grass_2.wav",
  footstepStone1: "/assets/sound/Generell Sounds/footstep_stone_1.wav",
  footstepStone2: "/assets/sound/Generell Sounds/footstep_stone_2.wav",
  footstepNether1: "/assets/sound/Generell Sounds/footstep_nether_1.wav",
  footstepNether2: "/assets/sound/Generell Sounds/footstep_nether_2.wav",
};

const musicUrls: Record<MusicKey, string> = {
  menu: "/assets/sound/01_Hauptmenue/01_Audios/1_BETT_Menue.wav",
  credits: "/assets/sound/04_Credits/01_Audios/4_BETT_Credits.wav",
  level1: "/assets/sound/01_WELT_Koriandergarten/01_Audios/2_BETT_Korianderworld.wav",
  dungeon: "/assets/sound/DUNGEON_Sounds/Dungeon_ATMO_v1.0.wav",
  moonlight: "/assets/sound/MOONLIGHT_Sounds/Moonlight_ATMO_v1.0.wav",
  horns: "/assets/sound/02_WELT_Unterwasserwelt/01_Audios/3_BETT_Underwaterworld2_Horns.wav",
  saveSpace: "/assets/sound/Save Space/Save_Space_atmo.wav",
};

export class AudioController {
  private readonly soundPool = new Map<SoundKey, HTMLAudioElement[]>();
  private readonly musicTracks = new Map<MusicKey, HTMLAudioElement>();
  private enabled = localStorage.getItem("labyrinthAudio") !== "off";
  private unlocked = false;
  private currentMusic: MusicKey | null = null;
  private pendingMusic: MusicKey | null = null;
  private temporaryMusic: MusicKey | null = null;
  private suspendedMusic: MusicKey | null = null;
  private seededState = 1;
  private seededRunActive = false;
  private footstepToggle = false;
  private lastFootstepAt = 0;
  private campFireBurningLoop: HTMLAudioElement | null = null;
  private fuelChargeLoop: HTMLAudioElement | null = null;
  private fuelLowCountdownLoop: HTMLAudioElement | null = null;
  private readonly deathVoiceKeys: ReadonlyArray<SoundKey> = [
    "overconfidence",
    "slowly",
    "slowDeath",
    "noHope",
    "disappointment",
  ];
  private readonly merchantVoiceKeys = new Set<SoundKey>([
    "shopAnytime",
    "shopNoMoney",
    "shopThankYou",
    "shopBuying",
  ]);

  constructor() {
    window.addEventListener("pointerdown", this.unlock, { once: true, capture: true });
    window.addEventListener("keydown", this.unlock, { once: true, capture: true });
  }

  isEnabled(): boolean {
    return this.enabled;
  }

  setRunSeed(seed: number): void {
    const normalized = Math.floor(Number(seed));
    if (!Number.isFinite(normalized) || normalized <= 0) {
      this.seededState = 1;
      this.seededRunActive = false;
      return;
    }
    this.seededState = (normalized >>> 0) || 1;
    this.seededRunActive = true;
  }

  setEnabled(enabled: boolean): void {
    this.enabled = enabled;
    localStorage.setItem("labyrinthAudio", enabled ? "on" : "off");
    if (!enabled) {
      this.clearTemporaryMusic();
      this.stopMusic();
      this.stopCampFireBurning();
      this.stopFuelCharge();
      this.stopLowFuelWarning();
    } else if (this.temporaryMusic) {
      this.playTemporaryMusic(this.temporaryMusic);
    } else if (this.currentMusic ?? this.pendingMusic) {
      this.playMusic(this.currentMusic ?? this.pendingMusic ?? "menu");
    }
  }

  toggleEnabled(): boolean {
    this.setEnabled(!this.enabled);
    return this.enabled;
  }

  playMusic(key: MusicKey): void {
    this.pendingMusic = key;
    if (this.temporaryMusic !== null) {
      this.suspendedMusic = key;
      return;
    }
    if (!this.enabled || !this.unlocked) return;
    if (this.currentMusic === key) return;
    this.stopMusic();
    const audio = this.musicFor(key);
    audio.currentTime = 0;
    audio.volume = this.musicVolume(key);
    void audio.play().then(() => {
      this.currentMusic = key;
    }).catch(() => {
      this.currentMusic = null;
    });
  }

  playTemporaryMusic(key: MusicKey): void {
    if (this.temporaryMusic === null) {
      this.suspendedMusic = this.currentMusic ?? this.pendingMusic;
    }
    this.temporaryMusic = key;
    if (!this.enabled || !this.unlocked) return;
    if (this.currentMusic === key) return;
    this.stopMusic();
    const audio = this.musicFor(key);
    audio.currentTime = 0;
    audio.volume = this.musicVolume(key);
    void audio.play().then(() => {
      this.currentMusic = key;
    }).catch(() => {
      this.currentMusic = null;
    });
  }

  resumeFromTemporaryMusic(): void {
    if (this.temporaryMusic === null) return;
    const temporaryKey = this.temporaryMusic;
    const temporaryTrack = this.musicTracks.get(temporaryKey);
    temporaryTrack?.pause();
    this.temporaryMusic = null;
    const resumeKey = this.suspendedMusic;
    this.suspendedMusic = null;
    if (!resumeKey || !this.enabled || !this.unlocked) {
      this.currentMusic = null;
      return;
    }
    const audio = this.musicFor(resumeKey);
    audio.volume = this.musicVolume(resumeKey);
    void audio.play().then(() => {
      this.currentMusic = resumeKey;
    }).catch(() => {
      this.currentMusic = null;
    });
  }

  clearTemporaryMusic(): void {
    if (this.temporaryMusic) {
      const temporaryTrack = this.musicTracks.get(this.temporaryMusic);
      temporaryTrack?.pause();
    }
    this.temporaryMusic = null;
    this.suspendedMusic = null;
  }

  stopMusic(): void {
    for (const audio of this.musicTracks.values()) {
      audio.pause();
    }
    this.currentMusic = null;
  }

  playSfx(key: SoundKey, volume = 0.72): void {
    if (!this.enabled || !this.unlocked) return;
    const audio = this.soundFor(key);
    audio.pause();
    audio.currentTime = 0;
    audio.volume = volume;
    void audio.play().catch(() => undefined);
  }

  stopSfx(key: SoundKey): void {
    const pool = this.soundPool.get(key);
    if (!pool) return;
    for (const audio of pool) {
      audio.pause();
      audio.currentTime = 0;
    }
  }

  playDoorUnlock(): void {
    this.playSfx("doorUnlock", 0.55);
  }

  playDoorLockedKnock(): boolean {
    return this.playSfxNoOverlap("doorClosed", 0.58);
  }

  playMiningLoop(surface: MiningSurface): void {
    this.stopMiningLoop();
    this.playSfx(miningLoopKey(surface), 0.56);
  }

  stopMiningLoop(): void {
    this.stopSfx("miningWallWood");
    this.stopSfx("miningWallStone");
    this.stopSfx("miningWallNether");
  }

  playMiningHit(surface: MiningSurface): void {
    this.playSfx(miningHitKey(surface), 0.6);
  }

  playRandomDeathVoiceLine(volume = 0.68): void {
    if (this.deathVoiceKeys.length === 0) return;
    for (const key of this.deathVoiceKeys) {
      this.stopSfx(key);
    }
    const index = this.seededRandomIndex(this.deathVoiceKeys.length);
    const key = this.deathVoiceKeys[index] ?? this.deathVoiceKeys[0];
    this.playSfx(key, volume);
  }

  playVoiceLine(key: SoundKey, volume = 0.72): void {
    if (!this.merchantVoiceKeys.has(key)) {
      this.playSfx(key, volume);
      return;
    }
    this.stopVoiceLines();
    this.playSfx(key, volume);
  }

  stopMerchantVoices(): void {
    this.stopVoiceLines();
  }

  startCampFireBurning(): void {
    if (!this.enabled || !this.unlocked) return;
    if (this.campFireBurningLoop && !this.campFireBurningLoop.paused && !this.campFireBurningLoop.ended) return;
    const audio = this.soundFor("campFireBurning");
    audio.pause();
    audio.currentTime = 0;
    audio.loop = true;
    audio.volume = 0.26;
    this.campFireBurningLoop = audio;
    void audio.play().catch(() => undefined);
  }

  stopCampFireBurning(): void {
    const audio = this.campFireBurningLoop;
    if (!audio) return;
    audio.pause();
    audio.currentTime = 0;
    audio.loop = false;
    this.campFireBurningLoop = null;
  }

  startFuelCharge(): void {
    if (!this.enabled || !this.unlocked) return;
    if (this.fuelChargeLoop && !this.fuelChargeLoop.paused && !this.fuelChargeLoop.ended) return;
    const audio = this.soundFor("fuelCharge");
    audio.pause();
    audio.currentTime = 0;
    audio.loop = true;
    audio.volume = 0.44;
    this.fuelChargeLoop = audio;
    void audio.play().catch(() => undefined);
  }

  stopFuelCharge(): void {
    const audio = this.fuelChargeLoop;
    if (!audio) return;
    audio.pause();
    audio.currentTime = 0;
    audio.loop = false;
    this.fuelChargeLoop = null;
  }

  updateLowFuelWarning(fuelNormalized: number, config: LowFuelWarningConfig, active = true): void {
    if (!active || !this.enabled || !this.unlocked) {
      this.stopLowFuelWarning();
      return;
    }
    const threshold = clamp01(config.threshold);
    if (threshold <= 0) {
      this.stopLowFuelWarning();
      return;
    }
    const normalizedFuel = clamp01(fuelNormalized);
    if (normalizedFuel > threshold) {
      this.stopLowFuelWarning();
      return;
    }

    const progress = clamp01((threshold - normalizedFuel) / threshold);
    if (progress <= 0) {
      this.stopLowFuelWarning();
      return;
    }

    const shaped = progress * progress;
    const minVolume = clamp01(config.minVolume);
    const maxVolume = clamp01(config.maxVolume);
    const maxPlaybackRate = Math.max(1, config.maxPlaybackRate);
    const audio = this.ensureLowFuelWarningLoop();
    audio.volume = lerp(minVolume, maxVolume, shaped);
    audio.playbackRate = lerp(1, maxPlaybackRate, shaped);
  }

  stopLowFuelWarning(): void {
    const audio = this.fuelLowCountdownLoop;
    if (!audio) return;
    audio.pause();
    audio.currentTime = 0;
    audio.loop = false;
    audio.playbackRate = 1;
    this.fuelLowCountdownLoop = null;
  }

  updateFootsteps(isMoving: boolean, surface: FootstepSurface): void {
    if (!isMoving) return;
    const now = performance.now();
    if (now - this.lastFootstepAt < 320) return;
    this.lastFootstepAt = now;
    this.footstepToggle = !this.footstepToggle;
    const pair = footstepPair(surface);
    this.playSfx(this.footstepToggle ? pair[0] : pair[1], 0.34);
  }

  destroy(): void {
    window.removeEventListener("pointerdown", this.unlock, { capture: true });
    window.removeEventListener("keydown", this.unlock, { capture: true });
    this.stopMusic();
    this.stopVoiceLines();
    this.stopMiningLoop();
    this.stopCampFireBurning();
    this.stopFuelCharge();
    this.stopLowFuelWarning();
    this.clearTemporaryMusic();
  }

  private readonly unlock = (): void => {
    this.unlocked = true;
    if (this.temporaryMusic) {
      this.playTemporaryMusic(this.temporaryMusic);
      return;
    }
    if (this.pendingMusic) {
      this.playMusic(this.pendingMusic);
    }
  };

  private musicFor(key: MusicKey): HTMLAudioElement {
    const existing = this.musicTracks.get(key);
    if (existing) return existing;
    const audio = createAudioElement(musicUrls[key]);
    audio.loop = true;
    this.musicTracks.set(key, audio);
    return audio;
  }

  private musicVolume(key: MusicKey): number {
    return key === "menu" || key === "credits" ? 0.24 : 0.18;
  }

  private soundFor(key: SoundKey): HTMLAudioElement {
    const pool = this.soundPool.get(key) ?? [];
    const reusable = pool.find((audio) => audio.paused || audio.ended);
    if (reusable) return reusable;
    const audio = createAudioElement(soundUrls[key]);
    pool.push(audio);
    this.soundPool.set(key, pool);
    return audio;
  }

  private ensureLowFuelWarningLoop(): HTMLAudioElement {
    const existing = this.fuelLowCountdownLoop;
    if (existing && !existing.paused && !existing.ended) {
      return existing;
    }
    const audio = this.soundFor("fuelLowCountdown");
    audio.pause();
    audio.currentTime = 0;
    audio.loop = true;
    enablePitchPreservation(audio);
    this.fuelLowCountdownLoop = audio;
    void audio.play().catch(() => undefined);
    return audio;
  }

  private playSfxNoOverlap(key: SoundKey, volume = 0.72): boolean {
    if (!this.enabled || !this.unlocked) return false;
    if (this.isSfxPlaying(key)) return false;
    const audio = this.soundFor(key);
    audio.pause();
    audio.currentTime = 0;
    audio.volume = volume;
    void audio.play().catch(() => undefined);
    return true;
  }

  private isSfxPlaying(key: SoundKey): boolean {
    const pool = this.soundPool.get(key);
    if (!pool) return false;
    return pool.some((audio) => !audio.paused && !audio.ended);
  }

  private stopVoiceLines(): void {
    for (const key of this.merchantVoiceKeys) {
      this.stopSfx(key);
    }
  }

  private seededRandomIndex(max: number): number {
    if (max <= 1) return 0;
    if (!this.seededRunActive) {
      return Math.floor(Math.random() * max);
    }
    this.seededState = (1664525 * this.seededState + 1013904223) >>> 0;
    return this.seededState % max;
  }
}

function footstepPair(surface: FootstepSurface): [SoundKey, SoundKey] {
  if (surface === "stone") return ["footstepStone1", "footstepStone2"];
  if (surface === "nether") return ["footstepNether1", "footstepNether2"];
  return ["footstepGrass1", "footstepGrass2"];
}

function miningLoopKey(surface: MiningSurface): SoundKey {
  if (surface === "stone") return "miningWallStone";
  if (surface === "nether") return "miningWallNether";
  return "miningWallWood";
}

function miningHitKey(surface: MiningSurface): SoundKey {
  if (surface === "stone") return "wallMinedStone";
  if (surface === "nether") return "wallMinedNether";
  return "wallMinedWood";
}

function clamp01(value: number): number {
  if (!Number.isFinite(value)) return 0;
  return Math.min(1, Math.max(0, value));
}

function lerp(from: number, to: number, t: number): number {
  return from + (to - from) * clamp01(t);
}

function enablePitchPreservation(audio: HTMLAudioElement): void {
  const media = audio as HTMLAudioElement & {
    preservesPitch?: boolean;
    mozPreservesPitch?: boolean;
    webkitPreservesPitch?: boolean;
  };
  media.preservesPitch = true;
  media.mozPreservesPitch = true;
  media.webkitPreservesPitch = true;
}

function createAudioElement(baseUrl: string): HTMLAudioElement {
  const audio = document.createElement("audio");
  audio.preload = "auto";
  const sources = candidateAudioSources(baseUrl);
  for (const sourceUrl of sources) {
    const source = document.createElement("source");
    source.src = encodeURI(sourceUrl);
    const type = mimeTypeForAudio(sourceUrl);
    if (type) source.type = type;
    audio.appendChild(source);
  }
  audio.load();
  return audio;
}

function candidateAudioSources(baseUrl: string): string[] {
  if (baseUrl.toLowerCase().endsWith(".wav")) {
    const mp3 = baseUrl.slice(0, -4) + ".mp3";
    const ogg = baseUrl.slice(0, -4) + ".ogg";
    return [mp3, ogg, baseUrl];
  }
  return [baseUrl];
}

function mimeTypeForAudio(url: string): string | null {
  const lower = url.toLowerCase();
  if (lower.endsWith(".ogg")) return "audio/ogg";
  if (lower.endsWith(".wav")) return "audio/wav";
  if (lower.endsWith(".mp3")) return "audio/mpeg";
  return null;
}
